import React from 'react'
import Typography from '@mui/material/Typography'
import { drawerWidth } from './ContentSidebar'
import logo from 'static/ejenta-logo.png'
import { Box } from '@mui/material'

export default function HeaderLogo (props) {
  const renderLogoContent = () => {
    return (
      <div className='logo'>
        <Box className='logo__base' sx={{ display: 'flex' }}>
          <img src={logo} alt='Ejenta' /> {props.isAnalyticsActive && <div className='logo__suffix'>Analytics</div>}
        </Box>
      </div>
    )
  }

  const renderDesktopVersion = () => {
    return (
      <Typography
        variant='h6'
        noWrap
        component='a'
        href='/'
        sx={{
          width: drawerWidth - 24, // account for left padding
          display: { xs: 'none', md: 'flex' },
          fontFamily: 'monospace',
          fontWeight: 700,
          textDecoration: 'none'
        }}
      >
        {renderLogoContent()}
      </Typography>
    )
  }

  const renderMobileVersion = () => {
    return (
      <Typography
        variant='h5'
        noWrap
        component='a'
        href=''
        sx={{
          mr: 2,
          display: { xs: 'flex', md: 'none' },
          flexGrow: 1,
          fontFamily: 'monospace',
          fontWeight: 700,
          letterSpacing: '.3rem',
          color: 'inherit',
          textDecoration: 'none'
        }}
      >
        {renderLogoContent()}
      </Typography>
    )
  }

  if (!props.forDesktop) {
    return renderMobileVersion()
  }

  return renderDesktopVersion()
}
